import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=607551ac&scoped=true&"
import script from "./Administration.vue?vue&type=script&lang=ts&"
export * from "./Administration.vue?vue&type=script&lang=ts&"
import style0 from "./Administration.vue?vue&type=style&index=0&id=607551ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607551ac",
  null
  
)

export default component.exports